/**
 * requestAnimationFrame polyfill
 */
import { isServer } from './index';
var prev = Date.now();
/* istanbul ignore next */

function fallback(fn) {
  var curr = Date.now();
  var ms = Math.max(0, 16 - (curr - prev));
  var id = setTimeout(fn, ms);
  prev = curr + ms;
  return id;
}
/* istanbul ignore next */


var root = isServer ? global : window;
/* istanbul ignore next */

var iRaf = root.requestAnimationFrame || fallback;
/* istanbul ignore next */

var iCancel = root.cancelAnimationFrame || root.clearTimeout;
export function raf(fn) {
  return iRaf.call(root, fn);
}
export function cancel(id) {
  iCancel.call(root, id);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.6.17@vant/es/utils/raf.js
// module id = BjNV
// module chunks = 11